import { Users, Store, ShoppingBag, Banknote } from 'lucide-react';

import { useSuperAdminDashboard } from '@/features/super-admin/hooks/useSuperAdminDashboard';
import StatCard from '@/features/super-admin/components/dashboard/StatCard';
import AnalyticsChart from '@/features/super-admin/components/dashboard/AnalyticsChart';

export default function SuperAdminDashboard() {
  const { data: metrics, isLoading, error } = useSuperAdminDashboard();

  if (isLoading) {
    return (
      <div className="dashboard-loading">
        در حال بارگذاری اطلاعات داشبورد...
      </div>
    );
  }

  if (error) {
    console.error(error);
  }

  return (
    <div>
      <h1 className="section-title">داشبورد سوپر ادمین</h1>

      <div className="kpi-grid">
        <StatCard
          title="کل کاربران"
          value={metrics?.total_users}
          subValue={`${metrics?.active_users ?? 0} کاربر فعال`}
          subValueType="success"
          icon={Users}
          accent="blue"
        />

        <StatCard
          title="فروشندگان"
          value={metrics?.total_vendors}
          subValue={`${metrics?.pending_vendors ?? 0} در انتظار تایید`}
          subValueType="warning"
          icon={Store}
          accent="amber"
        />

        <StatCard
          title="کل سفارشات"
          value={metrics?.total_orders}
          subValue="ثبت شده در سیستم"
          subValueType="neutral"
          icon={ShoppingBag}
          accent="purple"
        />

        <StatCard
          title="حجم کل فروش"
          value={`${metrics?.gross_sales_volume ?? '0'} تومان`}
          subValue="گردش مالی کل"
          subValueType="success"
          icon={Banknote}
          accent="green"
        />
      </div>

      <AnalyticsChart
        ordersByStatus={metrics?.orders_by_status ?? []}
        usersByRole={metrics?.users_by_role ?? []}
      />
    </div>
  );
}